var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"px-2 flex-initial",class:{
    'bg-white text-primary hover:bg-whitesmoke border-solid border border-info':
      _vm.inverted,
    'bg-primary hover:bg-primary-light text-white': !_vm.inverted,
  },on:{"click":_vm.onClick}},[(_vm.loading)?_c('IconComponent',{staticClass:"animate-spin",attrs:{"icon":"spinner","pack":"fas"}}):[(_vm.icon)?_c('IconComponent',{attrs:{"pack":_vm.iconPack,"icon":_vm.icon}}):_vm._e()],_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }